import { render, staticRenderFns } from "./BusinessOrderView.vue?vue&type=template&id=386c750b"
import script from "./BusinessOrderView.vue?vue&type=script&lang=js"
export * from "./BusinessOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports